import React from "react";
import { FiAlertTriangle, FiTrash2, FiX } from "react-icons/fi";

import Drawer from "./Drawer";

export default function ConfirmDeleteDrawer({
  open,
  page,
  loading,
  onClose,
  onConfirm,
}) {
  return (
    <Drawer
      open={open}
      onClose={onClose}
      title="Supprimer la page"
      subtitle="Cette action est irréversible."
      size="sm"
      footer={
        <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-end">
          <button
            type="button"
            onClick={onClose}
            disabled={loading}
            className="inline-flex items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-bold text-slate-700 transition hover:bg-slate-50 disabled:opacity-50 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200 dark:hover:bg-slate-800"
          >
            <FiX />
            Annuler
          </button>

          <button
            type="button"
            onClick={onConfirm}
            disabled={loading}
            className="inline-flex items-center justify-center gap-2 rounded-2xl bg-rose-600 px-4 py-3 text-sm font-bold text-white transition hover:bg-rose-700 disabled:opacity-50"
          >
            <FiTrash2 />
            {loading ? "Suppression…" : "Supprimer"}
          </button>
        </div>
      }
    >
      <div className="rounded-3xl border border-rose-200 bg-rose-50 p-5 text-rose-800 dark:border-rose-900/50 dark:bg-rose-950/30 dark:text-rose-200">
        <div className="flex items-start gap-3">
          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-rose-100 text-rose-700 dark:bg-rose-950 dark:text-rose-200">
            <FiAlertTriangle className="text-xl" />
          </div>

          <div>
            <h3 className="font-bold">Confirmation nécessaire</h3>

            <p className="mt-2 text-sm leading-6">
              Voulez-vous vraiment supprimer la page{" "}
              <strong>{page?.title || "sélectionnée"}</strong> ?
            </p>

            {page?.slug ? (
              <p className="mt-3 rounded-2xl bg-white/70 px-3 py-2 text-xs dark:bg-slate-950/50">
                Adresse concernée : <strong>/pages/{page.slug}</strong>
              </p>
            ) : null}

            <p className="mt-3 text-sm leading-6">
              Si cette page possède des sous-pages, le serveur refusera la
              suppression.
            </p>
          </div>
        </div>
      </div>
    </Drawer>
  );
}